import _get from "lodash/get";
import _find from "lodash/find";
import * as React from 'react';
import { ExperienceContext } from './ExperienceProvider';
export var ExperienceConsumer = function ExperienceConsumer(_ref) {
  var children = _ref.children;
  return React.createElement(ExperienceContext.Consumer, null, children);
};
export var getFirstOffer = function getFirstOffer(mboxOffer) {
  return _get(mboxOffer, 'content[0]') || {};
};
export var getAllOffers = function getAllOffers(mboxOffer) {
  return _get(mboxOffer, 'content') || [];
};
export var ExperienceSelector = function ExperienceSelector(_ref2) {
  var children = _ref2.children,
      mbox = _ref2.mbox,
      _ref2$multipleOffers = _ref2.multipleOffers,
      multipleOffers = _ref2$multipleOffers === void 0 ? false : _ref2$multipleOffers;
  return React.createElement(ExperienceContext.Consumer, null, function (_ref3) {
    var targetOffers = _ref3.targetOffers,
        loading = _ref3.loading;

    var mboxOffer = _find(targetOffers, function (offer) {
      return offer.mbox === mbox;
    });

    var content = multipleOffers ? getAllOffers(mboxOffer) : getFirstOffer(mboxOffer);
    return children(content, {
      loading: loading
    });
  });
};